/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sales_Return_Fee_TitleInputs */

const vi_sales_return_fee_title = /** @type {(inputs: Sales_Return_Fee_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phí trả hàng`)
};

/**

* @param {Sales_Return_Fee_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sales_return_fee_title = /** @type {((inputs?: Sales_Return_Fee_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sales_Return_Fee_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sales_return_fee_title(inputs)
});